import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-replacement-payment-details',
  templateUrl: './replacement-payment-details.component.html',
  styleUrl: './replacement-payment-details.component.css'
})
export class ReplacementPaymentDetailsComponent {
  imageUrls: string[] = [];

  @Input() awaitingEscalation: any;
  @Input() customerDetailCheck: any;
  @Input() kycComponentModeEnum: any;

  @Input() insurancePolicyFlag: boolean;
  @Output() replacementPay = new EventEmitter<any>();


  validateReplacementPay(check) {
    this.replacementPay.emit(check);
  }
}
